import {callAPI, callOauthAPI} from '@/store/utils';
import jwtDecode from 'jwt-decode';

const FYGR_OAUTH_ACCESS_TOKEN = 'FYGR_OAUTH_ACCESS_TOKEN';
const FYGR_ACCESS_TOKEN = 'FYGR_ACCESS_TOKEN';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async actionInitOauthRequest(_, data) {
      const res = await callOauthAPI('POST', 'initOauthRequest', data);
      return res;
    },
    async actionOauthSignUp(_, req) {
      const res = await callAPI('POST', 'signUp', req);
      return res;
    },
    async actionOauthSignIn(_, {username, password}) {
      const res = await callAPI('POST', 'signIn', {username, password});
      if (res.result.access_token) {
        localStorage.setItem(FYGR_ACCESS_TOKEN, res.result.access_token);
        localStorage.setItem(FYGR_OAUTH_ACCESS_TOKEN, res.result.access_token);
        const token = jwtDecode(res.result.access_token);
        if (token.is_active) {
          return token;
        }
        return {is_active: token.is_active};
      }
      return res;
    },
    async actionGetAuthorizationCode(_, data) {
      const res = await callOauthAPI('POST', 'getAuthorizationCode', data);
      if (res && res.error !== true && res.result && res.result.code) {
        const authorizationCode = res.result.code;
        return authorizationCode;
      }
      return null;
    },
    async actionAcceptConsent(_, data) {
      const res = await callOauthAPI('POST', 'acceptConsent', data);
      return res;
    },
  },
};
